import { render, staticRenderFns } from "./MdfeDetalhes.vue?vue&type=template&id=d0d9ae70"
import script from "./MdfeDetalhes.vue?vue&type=script&lang=js"
export * from "./MdfeDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports